<template>
  <tr
    class="text-body text-black-2 hover:bg-beige-0 transition-background duration-300 ease-in-out"
    :class="row.rowClass"
  >
    <td class="px-4! py-3! whitespace-nowrap">
      <slot name="variation-cell" :row="row" />
    </td>
    <template v-if="!isInvisible">
      <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
        {{ row.users }}
      </td>
      <td
        v-if="showImpressions"
        class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap"
      >
        {{ row.impressions }}
      </td>
    </template>
    <td v-if="isInvisible" class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
      {{ row.users }}
    </td>
    <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
      {{ row.goals }}
    </td>
    <td
      v-if="!isInvisible && shouldShowCTR"
      class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap"
    >
      {{ row.ctr }}
    </td>
    <td v-if="hasCustomGoal" class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
      {{ row.customGoals }}
    </td>
    <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
      {{ row.conversionRate }}
    </td>
    <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
      <span :style="row.confidence.style">{{ row.confidence.confidence }}</span>
    </td>
    <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
      {{ lastUpdatedText }}
    </td>
    <template v-if="accept2Enabled && !hasCustomGoal">
      <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
        {{ row.goals2 }}
      </td>
      <td class="rf-row--metric-col px-4! py-3! text-right whitespace-nowrap">
        {{ row.ctr2 }}
      </td>
      <slot name="row-additional" :row="row" />
    </template>
    <slot name="row-trailing" :row="row" />
  </tr>
</template>

<script setup>
defineProps({
  row: { type: Object, required: true },
  isInvisible: { type: Boolean, default: false },
  hasCustomGoal: { type: Boolean, default: false },
  accept2Enabled: { type: Boolean, default: false },
  shouldShowCTR: { type: Boolean, default: false },
  showImpressions: { type: Boolean, default: true },
  lastUpdatedText: { type: String, default: "" },
});
</script>

<style scoped>
.winner-row > td {
  background-color: color-mix(in srgb, #dcc214 8%, transparent) !important;
}
</style>
